import type React from "react";
import OTPVerificationForm from "./otp-verify-form.components";
import { useNavigate } from "react-router-dom";
import { useToast } from "../hooks/use-toast";
import { handleHttpError } from "../utils/utils";
import { useVerifyPhoneBrandHttp } from "../hooks/http/brand/users/verify-phone.brand.http";
import { useUserStore } from "../store/user.store";
import { useVerifyPhoneResendOtpBrandHttp } from "../hooks/http/brand/users/verify-phone-resend-otp.brand.http";
import { useAuthenticationStore } from "../store/authentication.store";
import { useDashboardConfigCommonHttp } from "../hooks/http/common/users/dashboard-config.common.http";

const OTPPhone: React.FunctionComponent = () => {
	const { authenticationState, setAuthenticationState } =
		useAuthenticationStore();
	const { fetching, execute: verifyOtpHttp } = useVerifyPhoneBrandHttp();
	const { execute: resendOtpHttp } = useVerifyPhoneResendOtpBrandHttp();
	const navigate = useNavigate();
	const { toast } = useToast();
	const { execute: fetchConfig } = useDashboardConfigCommonHttp();

	const { user, setUser, logout } = useUserStore();

	async function onResend() {
		const response = await resendOtpHttp({
			body: { id: authenticationState?.otp.id || "" },
		});
		if (!response.success) {
			return handleHttpError(response, toast);
		}
		setAuthenticationState({
			...authenticationState,
			otp: response.data,
		});
	}

	async function getConfig() {
		const response = await fetchConfig({ body: null });
		if (!response.success) {
			if (response.error.logout) {
				await logout();
			}
			return handleHttpError(response, toast);
		}
		setUser(response.data.user);
		if (response.data.brands.length === 0) {
			return;
		}

	}

	async function VerifyOtp(pin: string) {
		console.log(authenticationState?.otp);
		if (!authenticationState?.otp.id) {
			return toast({
				content: "error in getting id",
				toastType: "error",
			});
		}

		const response = await verifyOtpHttp({
			body: {
				id: authenticationState.otp.id,
				otp: pin,
			},
		});
		if (!response.success) {
			return toast({
				content: response.error.message,
				toastType: "error",
			});
		}
		toast({
			content: `Welcome Onboard ${user?.name} 🎉`,
			toastType: "success",
		});
		await getConfig();
		navigate("/");
	}

	if (!authenticationState) {
		return <></>;
	}

	return (
		<OTPVerificationForm
			title="Enter OTP"
			description={`enter the otp sent to +91-${authenticationState.phone}`}
			caller={VerifyOtp}
			loading={fetching}
			onResend={onResend}
			canResend={authenticationState.otp.canResend}
			resendIn={authenticationState.otp.resendIn}
		/>
	);
};

export default OTPPhone;
